<template>
  <div>
    <modal-layout-top :title="title" />

    <div class="content slider-modal">
      <div class="slider-modal-fields">
        <div class="field">
          <label class="label">Initialer</label>
          <input class="input" type="text" v-model="user.initials" />
        </div>

        <div class="field" v-if="!isUpdate">
          <label class="label">PIN</label>
          <input class="input" type="text" v-model="user.password" />
        </div>

        <div class="field">
          <label class="label">Roll</label>
          <div class="select">
            <select v-model="user.role">
              <option value="Staff">Konsult</option>
              <option value="SuperAdmin">SuperAdmin</option>
              <option value="Developer">Utvecklare</option>
            </select>
          </div>
        </div>

        <hr>

        <div class="field">
          <label class="label">Förnamn</label>
          <input class="input" type="text" v-model="user.firstName" />
        </div>

        <div class="field">
          <label class="label">Efternamn</label>
          <input class="input" type="text" v-model="user.lastName" />
        </div>

        <div class="field">
          <label class="label">Telefon</label>
          <input class="input" type="text" v-model="user.phone" />
        </div>

        <div class="field">
          <label class="label">E-post</label>
          <input class="input" type="text" v-model="user.email" />
        </div>
      </div>
      <modal-layout-buttons :store-name="'users'" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'

export default {
  name: 'user-modal',
  data () {
    return {
      user: { },
      isUpdate: false
    }
  },
  components: {
    ModalLayoutTop,
    ModalLayoutButtons
  },
  props: {
    id: {
      type: Number,
      required: false
    }
  },
  computed: {
    title () {
      if (!this.isUpdate) {
        return 'Skapa ny användare'
      } else {
        return 'Ändra ' + this.user.initials
      }
    }
  },
  methods: {
    ...mapActions('users', ['update', 'create', 'getById']),
    closePanel () {
      this.$emit('closePanel')
    },
    save () {
      if (this.user.userId) {
        this.update(this.user).then(() => {
          this.closePanel()
        }).catch(() => {
          this.$toast('Felaktig data', 'error')
        })
      } else {
        this.create(this.user).then(() => {
          this.closePanel()
        })
      }
    }
  },
  created () {
    this.$on('emitSave', () => {
      this.save()
    })

    if (!this.id) {
      this.user.role = 'Staff'
      this.isUpdate = false
    } else {
      this.getById(this.id).then((user) => {
        this.user = user
      })
      this.isUpdate = true
    }
  }
}
</script>

<style scoped lang="scss">
  /*.actions {
    position: absolute;
    bottom: 0;
    background-color: #eee !important;
    width: 100%;
    .button {
      margin: 20px 0 20px 20px;
    }
  }*/
</style>



// WEBPACK FOOTER //
// src/components/modals/UserModal.vue